import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../ListadoKeyUserScreenStyles';
import { Icon, Table, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { employeeById } from 'app/reducers';
import * as ListadoKeyUserActions from '../../../actions/ListadoKeyUserActions';
import { ListadoKeyUserReducer } from 'app/reducers/ListadoKeyUserReducer';
import { string } from 'prop-types';

const TableScreen = (props) => {
    let { dtsize } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)

    const employeeData = useSelector(employeeById);

    const {
        listAllKeyUser,
        isLoadingAllKeyUser,
        pagination,
    } = useSelector(state => state.ListadoKeyUserReducer);

    const dataSource = listAllKeyUser?.map(
        (record) => {
            return {
                'key': record.rownum,
                'idEmployee': record.idEmployee,
                'systemName': record.systemName,
                'keyUser': record.kuName,
                'dateAsig': record.dateAsig,
            }
        }
    );

    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    const convertDate = (date) => {
        let fechas = date.split("T");
        let dias = fechas[0].split("-");
        return `${dias[2]}-${dias[1]}-${dias[0]}`
    }

    const columns = [
        {
            title: 'KeyUser',
            dataIndex: 'keyUser',
            key: 'keyUser',
            sorter: true,
            ellipsis: true,
            width: 300

        },
        {
            title: 'Nombre',
            dataIndex: 'systemName',
            key: 'systemName',
            sorter: true,
            ellipsis: true,
            width: 250

        },
        {
            title: 'Fecha Asignación',
            dataIndex: 'dateAsig',
            key: 'dateAsig',
            sorter: true,
            ellipsis: true,
            width: 300,
            render: (text, record) => (
                <div>{convertDate(text)}</div>
            )
        },

    ];

    return (
        <div>
            <Table
                loading={isLoadingAllKeyUser}
                columns={columns}
                dataSource={dataSource}
                pagination={paginationTable}
                scroll={dtsize}
                size={"small"}
            />
        </div>
    )
}

export default TableScreen;
